import { Loader2 } from 'lucide-react'

export function ViewLoadingFallback() {
  return (
    <div className="flex items-center justify-center h-full">
      <Loader2 className="size-5 animate-spin text-muted-foreground" />
    </div>
  )
}
